import { jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { Box } from "@zillow/constellation-10";
import { resolveSpacing, v8ResponsiveToPanda } from "@zillow/zrs-cms";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const resolveAlignment = (value) => {
  const resolved = v8ResponsiveToPanda(value);
  const mapped = Object.fromEntries(Object.entries(resolved).map(([k, v]) => [k, v === "none" || v === "None" ? "auto" : v]));
  return Object.keys(mapped).length > 0 ? mapped : void 0;
};
const BlockGridLayout = ({
  attrs,
  index,
  innerBlocks
}) => {
  const {
    id,
    ...restAttrs
  } = attrs ?? {};
  const attributes = {
    gridTemplateColumns: {
      default: "repeat(12, minmax(0, 1fr))"
    },
    gap: {
      default: "md",
      lg_lte: "md",
      sm_lte: "md"
    },
    justifyContent: {
      default: "center"
    },
    alignItems: {
      default: "center"
    },
    // When child of things that center the content, we still want
    // Grid to be stretched. For example, as child of Carousel.
    alignSelf: {
      default: "stretch"
    },
    ...restAttrs
  };
  attributes.gap = {
    ...attributes.gap
  };
  if (attributes.gap.lg_lte === "xl" || !attributes.gap.lg_lte) {
    attributes.gap.lg_lte = "md";
  }
  if (attributes.gap.sm_lte === "lg" || attributes.gap.sm_lte === "xl" || !attributes.gap.sm_lte) {
    attributes.gap.sm_lte = "md";
  }
  const className = css({
    display: "grid",
    gridTemplateColumns: v8ResponsiveToPanda(attributes.gridTemplateColumns),
    gap: resolveSpacing(attributes.gap),
    justifyContent: resolveAlignment(attributes.justifyContent),
    alignItems: resolveAlignment(attributes.alignItems),
    alignSelf: resolveAlignment(attributes.alignSelf)
  });
  return /* @__PURE__ */ jsx(Box, { id, className, children: generateBlockList({
    blocks: innerBlocks
  }) }, index);
};
export {
  BlockGridLayout as default
};
